/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { Route } from '@angular/router';
import { allModalComponents } from './ui-modal-index';

export function loadModalInternal<K extends keyof typeof allModalComponents>(
  componentName: K,
): Promise<typeof allModalComponents[K]> {
  return import('./ui-modal-index').then(
    i => i.allModalComponents[componentName],
  );
}

export const uiModals: readonly Route[] = [
  {
    data: { loadModal: loadModalInternal('CameraModalComponent') },
    loadChildren: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
    path: 'hack_not_used',
  },
];
